import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6l16 0","key":"svg-0"}],["path",{"d":"M4 12l10 0","key":"svg-1"}],["path",{"d":"M4 18l14 0","key":"svg-2"}]]

const IconAlignLeft = createReactComponent('outline', 'align-left', 'AlignLeft', __iconNode);

export default IconAlignLeft;